import en from './en.json';
import zh from './zh-CN.json';
import tw from './zh-TW.json';
import VueI18n from 'vue-i18n';
import Cookie from 'js-cookie';
import Vue from 'vue'

Vue.use(VueI18n);

const locales = {
  en,
  'zh-CN': zh,
  'zh-TW': tw,
};

const DEFAULT_LANG = 'zh-CN';
const LOCALE_KEY = '_t_language';
let lang = DEFAULT_LANG;

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  fallbackLocale: 'zh-CN',
});

const format = (string, ...args) => {
  const RE_RANGES = /(%|)\{([0-9a-zA-Z_]+)\}/g;

  if (args.length === 1 && typeof args[0] === 'object') {
    args = args[0];
  }

  if (!args) {
    args = {};
  }

  return string.replace(RE_RANGES, (match, p1, p2, index) => {
    if (string[index - 1] === '{' && string[index + match.length] === '}')
      return p2;
    return args[p2] || '';
  });
};

const i18nHandler = (...args) => {
  const vuei18n = i18n;

  if (vuei18n) {
    lang = Cookie.get(LOCALE_KEY);
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG;
    }
    vuei18n.locale = lang;
    return vuei18n.t(...args);
  }
};

const setLang = l => {
  lang = l || lang;
};

const t = (path, options) => {
  let value = i18nHandler(path, options);

  if (value !== null && value !== undefined) return value;

  const array = path.split('.');
  value = locales[lang];
  for (let i = 0, len = array.length; i < len; i++) {
    const property = array[i];
    value = value[property];
    if (!value) return '';
    if (i === len - 1) return format(value, options);
  }
  return value;
};

export default {
  setLang,
  t,
};
